import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { IBookMeetingEntitlement, IReducerState } from '../../../states/renditionStates';
import * as asyncStateAction from '../../../actions/asyncStateAction';
import servicesConfig from '../../../services/servicesConfig';
import Author from './author';
import AuthorProfile from './authorProfile';
import _ from 'lodash';
import $ from 'jquery';
import commonStore from '../../../store/commonStore.js';
import * as commonStateAction from '../../../actions/commonStateAction';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import { getLinkId } from '../../../utils/general/general';
import AuthorOldBranding from './authorOldBranding';

interface IAuthorListProps {
    mainSource?: any;
    source?: any;
    editor?: any;
    teamDirectoryUrl?: string;
    bookMeetingUrl?: string;
    authorPageName?: string;
    initialData: any;
    // reportsToRevisit: any;
    analystInfoData: any;
    // getRR: (analystId: string, platform: string, channel: string, subChannel: string, doc_id: string) => {};
    getAnalystInfo: (analystId: string) => {};
    bookMeetingEntitlement: IBookMeetingEntitlement;
    getBookMeetingEntitlement: () => {};
    currentAuthorID: string;
    currentAuthorName: string;
    showOldBranding: boolean;
    analystSubscriptionData: any;
}

let showPartialAuthors = true;
let defaultAuthorsToShow = 2;
let haveThanksTo: any;
let currentLeftValue = 0;
let currentSlide = 1;

export class AuthorList extends PureComponent<IAuthorListProps, any> {
    constructor(props: IAuthorListProps) {
        super(props);
        if (this.props.initialData.isPublic){
            return;
        }
        // if (this.props.initialData.isEntitled('ANALYST_NAME')) {
        //     this.props.getRR(props.source.data?.map((e: any) => {
        //         return e.analystId;
        //     }).join(','), props.initialData.platform, props.initialData.channel, props.initialData['sub_channel'], props.initialData['doc_id']);
        // }
        if (getLinkId()) {
            return;
        }
        props.source.data && this.props.getAnalystInfo(props.source.data[0].analystId);
        const ajaxBookMeetingCheck : boolean = props.initialData.mode != 'preview_mode' && this.props.initialData.enableOpenDocBookMeetingCheck == false;
        if (ajaxBookMeetingCheck){
            this.props.getBookMeetingEntitlement();
        }
    }

    public componentDidMount() {
        // set default selected author
        $('#profiles_slideshow li').eq(0).addClass('selected');
        $('#authors div[data-serial=0]').removeClass('hide');
        commonStore.dispatch(commonStateAction.currentAuthorName(this.props.source.data[0].displayName));
        commonStore.dispatch(commonStateAction.currentAuthorID(this.props.source.data[0].analystId));
    }

    public render() {
        const { source, mainSource, analystInfoData, bookMeetingEntitlement,
            showOldBranding, initialData, teamDirectoryUrl, bookMeetingUrl, editor, getAnalystInfo, analystSubscriptionData } = this.props;
        if (!_.isEmpty(analystInfoData)) {
            mainSource.analystInfo = mainSource.analystInfo || {};
            $.extend(mainSource.analystInfo, analystInfoData);
        }

        showPartialAuthors = true;
        if (source.defaultAuthorsToShow) {
            defaultAuthorsToShow = +source.defaultAuthorsToShow;
        }

        let totalAuthors = source.data.length;
        if (source.data[totalAuthors - 1].displayName == "with_thanks_to") {
            totalAuthors--;
        }
        let eachSlideContainsAuthorCount = 5;
        let eachSlideWidth = eachSlideContainsAuthorCount * 65;

        const profilesSlideshowWidth = $("body").width() || 0;
        if (profilesSlideshowWidth < 370) {
            eachSlideContainsAuthorCount = 4;
            eachSlideWidth = eachSlideContainsAuthorCount * 65;
        }
        $(window).resize(() => {
            if (profilesSlideshowWidth < 370) {
                eachSlideContainsAuthorCount = 4;
                eachSlideWidth = eachSlideContainsAuthorCount * 65;
                authorPhotoShade.css({
                    "left": 265
                });
            } else {
                eachSlideContainsAuthorCount = 5;
                eachSlideWidth = eachSlideContainsAuthorCount * 65;
                authorPhotoShade.css({
                    "left": 320
                });
            }
        });

        let authorSlidesCount = ~~(totalAuthors / eachSlideContainsAuthorCount); // parse int
        if (totalAuthors % eachSlideContainsAuthorCount > 0) {
            authorSlidesCount += 1;
        }

        const sumWidth = totalAuthors * 65; // 65 means photo width 43 plus its margin 22
        let count = 0;
        const authors: any = [];
        const author_profiles: any = [];
        const withThanksAuthor: any = [];
        source.data.map((author: any, i: number) => {
            if (author.analystId && author.displayName != 'with_thanks_to') {
                authors.push(
                    showOldBranding ? <AuthorOldBranding showOldBranding={showOldBranding} key={'author' + i} initialData={initialData} mainSource={mainSource} source={source.data[count]} analystInfoData={analystInfoData}
                    editor={editor} teamDirectoryUrl={teamDirectoryUrl}  bookMeetingUrl={bookMeetingUrl} showPartialAuthors={showPartialAuthors} defaultAuthorsToShow={defaultAuthorsToShow} serial={count} bookMeetingEntitlement={bookMeetingEntitlement}></AuthorOldBranding> :
                    <Author showOldBranding={showOldBranding} key={'author' + i} initialData={initialData} mainSource={mainSource} source={source.data[count]} analystInfoData={analystInfoData}
                        editor={editor} teamDirectoryUrl={teamDirectoryUrl} bookMeetingUrl={bookMeetingUrl} showPartialAuthors={showPartialAuthors} defaultAuthorsToShow={defaultAuthorsToShow} serial={count} bookMeetingEntitlement={bookMeetingEntitlement} analystSubscriptionData={analystSubscriptionData}></Author>
                );
                author_profiles.push(
                    <AuthorProfile showOldBranding={showOldBranding} key={'authorProfile' + i} index={i} initialData={initialData} mainSource={mainSource} source={source.data[count]}
                        showPartialAuthors={showPartialAuthors} defaultAuthorsToShow={defaultAuthorsToShow} serial={count} getAnalystInfo={getAnalystInfo}></AuthorProfile>
                );
                count++;
            }
        });
        // Compatible old authors data structure: "with_thanks_to" authors in the same data array with other authors
        const helpingAuthors = source.helpingAuthors || [];
        let compatibleHelpingAuthorsLengthInAuthorsList = 0;
        if (helpingAuthors.length > 0) {
            haveThanksTo = true;
        } else {
            // old structure handle
            source.data.map((author: any, i: number) => {
                if (author.cftcValue && (author.displayName == 'with_thanks_to' || author.cftcValue.indexOf('With thanks to ') > -1)) {
                    helpingAuthors.push(author);
                    haveThanksTo = true;
                }
            });
            compatibleHelpingAuthorsLengthInAuthorsList = helpingAuthors.length;
        }
        helpingAuthors.map((author: any, i: number) => {
            withThanksAuthor.push(author.cftcValue);
        });

        const editorLabelText = count > 1 ? mainSource.i18n.editors : mainSource.i18n.editor;

        const tkas: any = [];
        if (withThanksAuthor.length > 0) {
            const strTemp = mainSource.metadata.isJP ? '協力 ' : 'With thanks to ';
            const tkaStr = (<React.Fragment key={withThanksAuthor.length}>
                                <div className="hline" />
                                    <div className="withThanksTo">
                                        <span className="wtt_header">{strTemp}</span>
                                        {withThanksAuthor.map((tka: string, index: number, arr: any) =>
                                            <React.Fragment key={index}>
                                                {(arr.length > 1) ? (<div className="text-overflow">{tka}</div>) : (<span className="text-overflow">{tka}</span>)}
                                            </React.Fragment>
                                        )}
                                </div>
                            </React.Fragment>);
            tkas.push(tkaStr);
        }
        const authorPhotoShade = $("#authorPhotoShade");
        if (profilesSlideshowWidth < 370) {
            authorPhotoShade.css({
                "left": 265
            });
        }

        const slideBtnClick =(event: any) => {
            if ($(event.target).hasClass('author_next')) {
                currentLeftValue = currentLeftValue - eachSlideWidth;
                currentSlide++;
                if (currentLeftValue <= -sumWidth) {
                    currentLeftValue = 0;
                    currentSlide = 1;
                }
            } else {
                currentLeftValue = currentLeftValue + eachSlideWidth;
                currentSlide--;
                if (currentLeftValue > 0) {
                    currentLeftValue = -(authorSlidesCount - 1) * eachSlideWidth;
                    currentSlide = authorSlidesCount;
                }
            }

            $('#author_profiles').animate({
                left: currentLeftValue
            }, 300);

            const eq = (currentSlide - 1) * eachSlideContainsAuthorCount;

            $('#profiles_slideshow li').removeClass('selected');
            $('#profiles_slideshow li').eq(eq).addClass('selected');

            const seq = $('#profiles_slideshow').find('.selected').index();

            $('#authors .author_card').addClass('hide');
            $('#authors div[data-serial=' + seq + ']').removeClass('hide');

            commonStore.dispatch(commonStateAction.currentAuthorName(source.data[seq]?.displayName));
            commonStore.dispatch(commonStateAction.currentAuthorID(source.data[seq]?.analystId));
            setTimeout(() => {  // use the timeout to trigger the state change in redux
                if (mainSource.analystInfo && !(this.props.currentAuthorID in mainSource.analystInfo)) {
                    this.props.getAnalystInfo(this.props.currentAuthorID);
                }
            }, 50);
        };
        const showSlideBtns = () => {
            if (profilesSlideshowWidth < 370) {
                return (source.data.length - compatibleHelpingAuthorsLengthInAuthorsList) > 4;
            } else {
                return (source.data.length - compatibleHelpingAuthorsLengthInAuthorsList) > 5;
            }
        };

        const showEditorsLabel = () => {
            try {
                return mainSource.issuerPage.financialsBlock.showEditorsLabel;
            } catch (e) {
                return false;
            }
        };
        const add5LinesHeight = () => {
            let author5Lines = '';
            mainSource.authors.data.forEach((author: any) => {
                if (author.headingValue) {
                    author5Lines = 'author5Lines';
                }
            });
            return author5Lines;
        };

        return (
            !window.HTML_RENDITION.isPoint &&
            <div className="author-list-part author_block">
                <div id="profiles_slideshow">
                    {showSlideBtns() && <span tabIndex={0} role="button" aria-label="check previous author"
                        onClick={(e) => slideBtnClick(e)}
                        onKeyPress={(e) => enterKeyPressed(e, slideBtnClick.bind(this, e))}
                        className="author_prev author_slide_icon"></span>}
                    <div id="authorPhotoShade" style={{ zIndex: 9, backgroundColor: 'white', width: '400px', height: '79px', left: '320px', position: 'absolute' }}></div>
                    <div className="author_slide_container">
                        <ul style={{ width: sumWidth + 'px' }} id="author_profiles">{author_profiles}</ul>
                    </div>
                    {showSlideBtns() && <span tabIndex={0} role="button" aria-label="check next author" onClick={(e) => slideBtnClick(e)} onKeyPress={(e) => enterKeyPressed(e, slideBtnClick.bind(this, e))} className="author_next author_slide_icon"></span>}
                </div>
                <div id="authors" className={"authors " + add5LinesHeight()}>
                    {showEditorsLabel() && <div className="editors">{editorLabelText}</div>}
                    {authors}
                    {tkas}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        initialData: state.asyncStateReducer.initialData,
        // reportsToRevisit: state.asyncStateReducer.reportsToRevisit,
        analystInfoData: state.asyncStateReducer.analystInfoDataById,
        currentAuthorID: state.commonStateReducer.currentAuthorID,
        currentAuthorName: state.commonStateReducer.currentAuthorName,
        bookMeetingEntitlement: state.asyncStateReducer.bookMeetingEntitlement
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
    // getRR: (analystId: string, platform: string, channel: string, subChannel: string, doc_id: string) => dispatch(
    //     asyncStateAction.fetchReportsToRevisit(Object.assign(servicesConfig.GET_REPORTS_TO_REVISIT, {
        //         'url_parameter': [
        //             'analystId=' + analystId,
        //             'platform=' + platform,
        //             'channel=' + channel,
        //             'sub-channel=' + subChannel,
        //             'doc_id=' + doc_id,
        //         ]
        //     }))),
        getAnalystInfo: (analystId: string) => dispatch(asyncStateAction.fetchAnalystInfoById(servicesConfig.GET_ANALYST_INFO, analystId)),
        getBookMeetingEntitlement: () => dispatch(asyncStateAction.getBookMeetingEntitlement(servicesConfig.getBookMeetingEntitlement))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorList);
